module.exports = __webpack_public_path__ + "static/img/200148.0be0e893.png";